import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Button from '@magalu/stereo-ui/atoms/Button';
export var ButtonStyled = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  border-color: ", ";\n  box-shadow: ", ";\n  color: ", ";\n"])), function (props) {
  return props.padding;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.borderColor;
}, function (props) {
  return props.boxShadow;
}, function (props) {
  return props.color;
});